import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { aiVideoSelectors } from 'store/features/aiVideo/selectors'
import {
  activeMediaItemImgPath,
  activeMediaItemStatus,
  selectActiveMedia
} from 'store/selectors'
import { MediaStatus } from 'types/media'
import { isBlobUrl } from 'utils'

export const useGetDisabledState = () => {
  const activeMedia = useSelector(selectActiveMedia)
  const imgFilePath = useSelector(activeMediaItemImgPath)
  const activeMediaStatus = useSelector(activeMediaItemStatus)
  const generationParams = useSelector(aiVideoSelectors.generationParams)

  const isAlreadyInAnimate = useMemo(
    () => generationParams.targetMediaItemId === activeMedia?.id,
    [generationParams.targetMediaItemId, activeMedia]
  )

  const isPendingStatus = useMemo(
    () => activeMediaStatus === MediaStatus.PENDING,
    [activeMediaStatus]
  )

  const isDisabled = useMemo(() => {
    return (
      isAlreadyInAnimate ||
      isPendingStatus ||
      !imgFilePath ||
      isBlobUrl(imgFilePath)
    )
  }, [imgFilePath, isPendingStatus, isAlreadyInAnimate])

  return isDisabled
}
